import api from '../utils/api'
import axios from 'axios'
import {
  GET_PROFILE,
  PROFILE_ERROR,
  CLEAR_PROFILE,
  ACCOUNT_DELETED,
  GET_PROFILE_STUDENT_BY_ID_SUCCESS,
  GET_PROFILE_STUDENT_BY_ID_ERROR,
  SET_LOADING_TRUE,
} from './types'
import { toast } from 'react-toastify'

// Get current users profile
export const getCurrentProfile = () => async (dispatch) => {
  try {
    const res = await api.get('/profileStudent/me')

    dispatch({
      type: GET_PROFILE,
      payload: res.data,
    })
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.data.msg, status: err.response.status },
    })
  }
}

// Create or update profile
export const createOrUpdateProfile =
  (data, history, edit = false) =>
    async (dispatch) => {
      const {
        imageAvatar,
        selectedImageAvatar,
        address,
        dateOfBirth,
        gender,
        englishLevel,
        introduction,
        skypeId,
        phoneNumber,
      } = data

      let newImageAvatar
      if (selectedImageAvatar) {
        const formData = new FormData()
        formData.append('file', selectedImageAvatar)
        formData.append('upload_preset', 'studentAvatar')

        const res = await axios.post(
          'https://api.cloudinary.com/v1_1/youspeak/image/upload',
          formData
        )

        newImageAvatar = await res.data.public_id
      }

      const newData = {
        imageAvatar,
        selectedImageAvatar: newImageAvatar,
        address,
        dateOfBirth,
        gender,
        englishLevel,
        introduction,
        skypeId,
        phoneNumber,
      }

      try {
        dispatch({
          type: SET_LOADING_TRUE,
        })

        const res = await api.post('/profileStudent', newData)

        dispatch({
          type: GET_PROFILE,
          payload: res.data,
        })

        edit
          ? toast.success('Thông tin đã được cập nhật')
          : toast.success('Thông tin đã được tạo')

        history.push('/dashboard')
      } catch (err) {
        dispatch({
          type: PROFILE_ERROR,
          payload: { msg: err.response.statusText, status: err.response.status },
        })
      }
    }

// Delete account & profile
export const deleteAccount = () => async (dispatch) => {
  if (window.confirm('Are you sure? This can NOT be undone!')) {
    try {
      await api.delete('/profileStudent')

      dispatch({ type: CLEAR_PROFILE })
      dispatch({ type: ACCOUNT_DELETED })

      toast.success('Your account has been permanently deleted')
    } catch (err) {
      dispatch({
        type: PROFILE_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      })
    }
  }
}

// Get student's profile by id
export const getProfileStudentById = (studentId) => async (dispatch) => {
  try {
    const res = await api.get(`/profileStudent/${studentId}`)

    dispatch({ type: GET_PROFILE_STUDENT_BY_ID_SUCCESS, payload: res.data })
  } catch (err) {
    dispatch({
      type: GET_PROFILE_STUDENT_BY_ID_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    })
  }
}
